/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Company\Company.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday July 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday July 18th 2023 4:37:54 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import TitlePage from "Content/HeadingPage/TitlePage/TitlePage";
import translator from "MultiLanguage/TranslationWrapper";
import { CompanyDataType } from "Type/company.type";
import { useLoaderData } from "react-router-dom";
import Styles from "Content/Company/Company.module.css";
import ModalCompany from "Content/Modals/ModalCompany/ModalCompany";
import { useState, MouseEvent } from "react";
import { Button } from "react-bootstrap";
import CompanyService from "Services/CompanyService/CompanyService";
import { formatSiren } from "Utils/company.utils";

function Company() {
    const [showModalCompany, setShowModalCompany] = useState(false);
    const loadData = useLoaderData() as CompanyDataType;
    const date = new Date(loadData.CreatedAt);
    const [updatableFileds, setUpdatableFileds] = useState({
        Name: undefined,
        Siren: undefined,
        StandardPhoneNumber: undefined,
        Address: undefined,
        PostalCode: undefined,
        City: undefined,
        State: undefined,
        Country: undefined,
    });

    const openModalCompany = (e: any) => {
        e.stopPropagation();
        setShowModalCompany(true);
    };

    const handleToggleCompanyModal = (e: MouseEvent<HTMLElement>) => {
        setShowModalCompany(false);
    };

    return (
        <div className="p-3">
            <TitlePage title={translator.decode("dynamic.company")} />
            <div className={`${Styles.holderCompany}`}>
                <div className={`${Styles.information}`}>
                    <span>{translator.decode("dynamic.company")}: {updatableFileds.Name ?? loadData.Name}</span>
                    <span>{translator.decode("dynamic.siren")} {updatableFileds.Siren ?? formatSiren(loadData.Siren)}</span>
                    <span>{translator.decode("dynamic.createdAt")} {date.toLocaleDateString()}</span>
                    <span>{translator.decode("dynamic.standard")}: {updatableFileds.StandardPhoneNumber ?? loadData.StandardPhoneNumber}</span>
                </div>
                <div className={`${Styles.address}`}>
                    <span>{translator.decode("dynamic.address")}: {updatableFileds.Address ?? loadData.Address}</span>
                    <span>{translator.decode("dynamic.postalcode")}: {updatableFileds.PostalCode ?? loadData.PostalCode}</span>
                    <span>{translator.decode("dynamic.city")}: {updatableFileds.City ?? loadData.City}</span>
                    <span>{translator.decode("dynamic.state")}: {updatableFileds.State ?? loadData.State}</span>
                    <span>{translator.decode("dynamic.country")}: {updatableFileds.Country ?? loadData.Country}</span>
                </div>
            </div>
            <Button onClick={openModalCompany}>{translator.decode("dynamic.modify")}</Button>
            <ModalCompany updateCompany={setUpdatableFileds} CompanyID={loadData.id} data={loadData} submitFunc={CompanyService.updateCompany} title={translator.decode("dynamic.company")} show={showModalCompany} onClose={handleToggleCompanyModal} closeModal={handleToggleCompanyModal} />
        </div>
    )
};

export default Company;
